import React, { useMemo } from 'react';

import DynamicFormWidget from '@components/dynamic-form/DynamicFormWidget';
import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { useCloseProposal } from '@common/slices/drawer.slice';
import { IAbstractRecord } from '@models';
import { IBaseDrawerProps } from '@common/types';
import { RootState } from '@core/redux/store';
import { useSelector } from 'react-redux';

interface Props extends IBaseDrawerProps {
  id?: string;
}

export interface ICloseProposalInfo {
  id: string;
  closingReason: string;
}

const CloseProposalDrawer: React.FC<Props> = ({ id, onSuccess }) => {
  const [closeProposalMutation] = useCloseProposal();

  const submitButtonState = useSelector(
    (state: RootState) => state.apiState.buttonState
  );

  const sections: IDynamicFormWidgetSection[] = useMemo(
    () => [
      {
        inputs: {
          closingReason: {
            name: 'closingReason',
            title: 'Closing Reason',
            placeholder: 'Select Closing Reason',
            type: FormFieldType.select,
            required: true,
            selectOptions: {
              'Premium is high': 'Premium is high',
              'Waiting for authority': 'Waiting for authority',
              'Above limits': 'Above limits'
            },
            value: ''
          }
        }
      }
    ],
    []
  );

  const onSubmit = async (values: IAbstractRecord) => {
    const res = await closeProposalMutation({
      entityId: id,
      closingReason: values.closingReason
    });
    if (!res.errors) {
      onSuccess();
    }
  };

  return (
    <DynamicFormWidget
      sections={sections}
      onSubmit={onSubmit}
      submitButtonState={submitButtonState}
    />
  );
};

export { CloseProposalDrawer };
